(function () {
  const STORAGE_KEY = 'da_destination_country';
  const STORAGE_MANUAL_KEY = 'da_destination_country_manual';
  const FLAG_BASE = 'https://flagcdn.com/16x12/';
  const CN_WAREHOUSE_NAME = 'CN Warehouse';
  const INTERNATIONAL_DELIVERY_REGION = 'International';

  function resolveUiRegions(config) {
    const uiList = Array.isArray(config.ui_regions) && config.ui_regions.length
      ? config.ui_regions
      : (config.fallback_countries || []).map(function (c) {
          return { code: c.code, name: c.name };
        });
    const rows = config.country_warehouse_rows || [];
    const warehouseEntries = (config.destination_warehouse && config.destination_warehouse.entries) || [];
    const warehouseToUiCodeMap = config.warehouse_to_ui_code || {};

    return uiList.map(function (item) {
      const uiCode = normalizeRegionCode(item.code) || item.code;
      const uiIso = uiCode === 'UK' ? 'GB' : uiCode;
      let warehouse = null;

      const row = findPrimaryWarehouseRowForCountry(rows, uiIso);
      if (row && row.warehouse) {
        warehouse = row.warehouse;
      }

      if (!warehouse) {
        const targetRegion = normalizeDeliveryRegion(uiCode);
        const matchByDelivery = warehouseEntries.find(function (entry) {
          return entry && normalizeDeliveryRegion(entry.delivery_region) === targetRegion;
        });
        if (matchByDelivery) {
          warehouse = matchByDelivery.warehouse_name;
        }
      }

      if (!warehouse) {
        const matchByUi = Object.keys(warehouseToUiCodeMap).find(function (whName) {
          return warehouseToUiCodeMap[whName] === uiCode;
        });
        if (matchByUi) warehouse = matchByUi;
      }

      if (!warehouse) warehouse = CN_WAREHOUSE_NAME;

      return {
        code: uiCode,
        name: item.name,
        warehouse: warehouse,
      };
    });
  }

  function buildWarehouseToUiCode(destinationWarehouse) {
    const map = {};
    const entries = (destinationWarehouse && destinationWarehouse.entries) || [];
    entries.forEach(function (entry) {
      if (!entry || !entry.warehouse_name) return;
      const region = normalizeDeliveryRegion(entry.delivery_region);
      if (!region || region === INTERNATIONAL_DELIVERY_REGION) {
        map[entry.warehouse_name] = null;
      } else {
        map[entry.warehouse_name] = normalizeRegionCode(region);
      }
    });
    return map;
  }

  const STATUS_DOT_HTML = '<span class="destination-availability__status-dot" aria-hidden="true"></span>';

  function parseJsonScript(root, selector) {
    const script = root.querySelector(selector);
    if (!script) return null;
    try {
      return JSON.parse(script.textContent);
    } catch (e) {
      return null;
    }
  }

  function bundlerHasContent() {
    const target = document.getElementById('bundler-target-element');
    if (target?.querySelector('.bndlr-container')) return true;
    return Boolean(document.querySelector('.bundler-target-element .bndlr-container'));
  }

  function getBundlerObserveTarget() {
    return (
      document.getElementById('bundler-target-element') ||
      document.querySelector('.product__info-container') ||
      document.body
    );
  }

  function updateBundleNoteVisibility(bundleNote) {
    if (!bundleNote) return;
    bundleNote.hidden = !bundlerHasContent();
  }

  function normalizeRegionCode(code) {
    if (!code) return null;
    const normalized = String(code).trim().toUpperCase();
    if (normalized === 'GB') return 'UK';
    return normalized;
  }

  function getCountryName(config, code) {
    const uiCode = normalizeRegionCode(code) || code;
    const match = (config.countries || []).find(function (c) {
      return c.code === uiCode;
    });
    if (match) return match.name;

    const lookupMatch = (config.country_name_lookup || []).find(function (c) {
      return c.code === code || c.code === uiCode;
    });
    if (lookupMatch) return lookupMatch.name;

    return uiCode;
  }

  /**
   * Shop metafield custom.destination_country_regions:
   * [{ "country": "DE", "warehouse": "EU Warehouse" }, ...]
   * Legacy object map { "DE": "EU" } still accepted.
   */
  function parseCountryWarehouseRows(raw) {
    let data = raw;
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) {
        return [];
      }
    }
    if (!data) return [];

    if (Array.isArray(data)) {
      return data
        .filter(function (row) {
          return row && row.country && row.warehouse;
        })
        .map(function (row) {
          return {
            country: String(row.country).trim().toUpperCase(),
            warehouse: String(row.warehouse).trim(),
          };
        });
    }

    if (typeof data === 'object') {
      return Object.keys(data).map(function (country) {
        const value = data[country];
        let warehouse = value;
        if (value === 'US') warehouse = 'US Warehouse';
        else if (value === 'CA') warehouse = 'CA Warehouse';
        else if (value === 'EU') warehouse = 'EU Warehouse';
        else if (value === 'GB' || value === 'UK') warehouse = 'UK Warehouse';
        else if (value === 'International' || value === 'CN') warehouse = CN_WAREHOUSE_NAME;
        return {
          country: String(country).trim().toUpperCase(),
          warehouse: String(warehouse).trim(),
        };
      });
    }

    return [];
  }

  function getUiRegionByCode(code, config) {
    const uiCode = normalizeRegionCode(code);
    const list = (config && config.ui_regions_resolved) || [];
    return list.find(function (region) {
      return region.code === uiCode;
    }) || null;
  }

  function warehouseToUiCode(warehouseName, isoCountry, config) {
    if (!warehouseName) return null;
    if (warehouseName === CN_WAREHOUSE_NAME) {
      const iso = normalizeRegionCode(isoCountry);
      const list = (config && config.ui_regions_resolved) || [];
      const cnRegion = list.find(function (region) {
        return region.warehouse === CN_WAREHOUSE_NAME && region.code === iso;
      });
      return cnRegion ? cnRegion.code : null;
    }
    const map = (config && config.warehouse_to_ui_code) || {};
    return map[warehouseName] != null ? map[warehouseName] : null;
  }

  /** Prefer local warehouse when a country has both local + CN rows. */
  function findPrimaryWarehouseRowForCountry(rows, iso) {
    const matches = (rows || []).filter(function (entry) {
      return entry.country === iso || (iso === 'GB' && entry.country === 'GB');
    });
    if (!matches.length) return null;
    const local = matches.find(function (entry) {
      return entry.warehouse !== CN_WAREHOUSE_NAME;
    });
    return local || matches[0];
  }

  function mapIsoToUiRegion(isoCode, config) {
    const raw = normalizeCountryCode(isoCode);
    if (!raw) return null;

    const uiDirect = normalizeRegionCode(raw);
    if (getUiRegionByCode(uiDirect, config)) return uiDirect;

    const rows = parseCountryWarehouseRows(config.destination_country_regions);
    const row = findPrimaryWarehouseRowForCountry(rows, raw);
    if (!row) return null;

    return warehouseToUiCode(row.warehouse, raw, config);
  }

  function resolveWarehouseForUiRegion(uiCode, config) {
    const region = getUiRegionByCode(uiCode, config);
    if (region) return region.warehouse;

    const rows = parseCountryWarehouseRows(config.destination_country_regions);
    const iso = uiCode === 'UK' ? 'GB' : uiCode;
    const row = findPrimaryWarehouseRowForCountry(rows, iso);
    return row ? row.warehouse : null;
  }

  /**
   * CN fallback only if at least one country that uses this region's primary
   * warehouse also has a destination_country_regions row for CN Warehouse.
   */
  function uiRegionAllowsCnFallback(uiCode, config) {
    const primaryWarehouse = resolveWarehouseForUiRegion(uiCode, config);
    if (!primaryWarehouse || primaryWarehouse === CN_WAREHOUSE_NAME) return false;

    const rows = parseCountryWarehouseRows(config.destination_country_regions);
    if (!rows.length) return false;

    const countriesWithPrimary = {};
    rows.forEach(function (row) {
      if (row.warehouse === primaryWarehouse) countriesWithPrimary[row.country] = true;
    });

    const uiIso = uiCode === 'UK' ? 'GB' : uiCode;
    if (uiCode !== 'EU') countriesWithPrimary[uiIso] = true;

    return rows.some(function (row) {
      return row.warehouse === CN_WAREHOUSE_NAME && countriesWithPrimary[row.country];
    });
  }

  function buildCountriesFromConfig(config) {
    const rows = parseCountryWarehouseRows(config.destination_country_regions);
    config.country_warehouse_rows = rows;
    config.warehouse_to_ui_code = buildWarehouseToUiCode(config.destination_warehouse);
    const regions = resolveUiRegions(config);
    config.ui_regions_resolved = regions;
    const countries = regions.map(function (region) {
      return {
        code: region.code,
        name: region.name,
        warehouse: region.warehouse,
      };
    });

    return {
      countries: countries,
      regions_panel_countries: countries.map(function (c) {
        return c.code;
      }),
      country_source: rows.length ? 'metafield' : 'fallback',
      country_warehouse_rows: rows,
    };
  }

  function applyCountryConfig(element, config) {
    const resolved = buildCountriesFromConfig(config);

    config.countries = resolved.countries;
    config.regions_panel_countries = resolved.regions_panel_countries;
    config.country_source = resolved.country_source;
    config.country_warehouse_rows = resolved.country_warehouse_rows;

    element.dataset.countrySource = resolved.country_source;
    element.dataset.countryRegionsLoaded = resolved.country_source === 'metafield' ? 'true' : 'false';
    element.dataset.countryCount = String(resolved.countries.length);

    if (config.destination_warehouse) {
      element.dataset.destinationWarehouseConfigured = config.destination_warehouse.configured ? 'true' : 'false';
      element.dataset.destinationWarehouseCount = String(config.destination_warehouse.count || 0);
    }

    return config;
  }

  function flagUrl(code) {
    const uiCode = normalizeRegionCode(code) || code;
    const flagCode = uiCode === 'UK' ? 'gb' : String(uiCode || '').toLowerCase();
    return FLAG_BASE + flagCode + '.png';
  }

  function unavailableFallback(config, country) {
    const countryName = getCountryName(config, country);
    const template = (config.strings && config.strings.not_available_for) || 'Not available for delivery to {{ country }} at this time';
    return {
      country: country,
      status: 'unavailable',
      status_label: (config.strings && config.strings.currently_unavailable) || 'Currently unavailable',
      shipping_text: null,
      unavailable_message: template.replace('{{ country }}', countryName),
    };
  }

  /**
   * ERP metafield custom.da_warehouse_availability (JSON array):
   * [{ warehouse, quantity, country }, ...]
   */
  function parseWarehouseAvailabilityEntries(raw) {
    if (!raw) return [];
    let data = raw;
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) {
        return [];
      }
    }
    if (!Array.isArray(data)) return [];

    return data.filter(function (entry) {
      return entry && entry.warehouse;
    });
  }

  function buildShippingText(warehouse, mode) {
    if (!warehouse) return null;
    if (mode === 'local') {
      const label = warehouse.shipping_label_local || ('Ships from ' + (warehouse.warehouse_name || 'warehouse'));
      const eta = warehouse.eta_local ? ' · Est. ' + warehouse.eta_local : '';
      return label + eta;
    }
    const label = warehouse.shipping_label_international || 'Ships internationally';
    const eta = warehouse.eta_international ? ' · Est. ' + warehouse.eta_international : '';
    return label + eta;
  }

  function findWarehouseEntry(warehouses, warehouseName) {
    return (warehouses || []).find(function (warehouse) {
      return warehouse.warehouse_name === warehouseName;
    }) || null;
  }

  function etaDaysMinValue(warehouse) {
    const n = Number(warehouse && warehouse.eta_days_min);
    return Number.isFinite(n) ? n : Number.POSITIVE_INFINITY;
  }

  function normalizeDeliveryRegion(region) {
    if (!region) return '';
    const normalized = String(region).trim();
    if (normalized.toUpperCase() === 'UK') return 'GB';
    return normalized;
  }

  function getWarehousesByDeliveryRegion(warehouses, deliveryRegion) {
    const region = normalizeDeliveryRegion(deliveryRegion);
    if (!region) return [];
    return (warehouses || []).filter(function (warehouse) {
      return normalizeDeliveryRegion(warehouse.delivery_region) === region;
    });
  }

  function buildStockByWarehouseName(entries) {
    const stock = {};
    (entries || []).forEach(function (entry) {
      if (!entry || !entry.warehouse) return;
      stock[entry.warehouse] = (stock[entry.warehouse] || 0) + (Number(entry.quantity) || 0);
    });
    return stock;
  }

  /**
   * Among candidates with qty > 0, pick lowest eta_days_min (then name).
   * Works for 1 warehouse/region today and N warehouses/region later.
   */
  function pickBestInStockWarehouse(candidates, stockByName) {
    const withStock = (candidates || []).filter(function (warehouse) {
      return warehouse && warehouse.warehouse_name && (stockByName[warehouse.warehouse_name] || 0) > 0;
    });
    if (!withStock.length) return null;

    withStock.sort(function (a, b) {
      const diff = etaDaysMinValue(a) - etaDaysMinValue(b);
      if (diff !== 0) return diff;
      return String(a.warehouse_name).localeCompare(String(b.warehouse_name));
    });
    return withStock[0];
  }

  function computeMetafieldAvailability({ variantId, country, config }) {
    const uiCode = normalizeRegionCode(country) || country;
    const primaryWarehouseName = resolveWarehouseForUiRegion(uiCode, config);
    if (!primaryWarehouseName) {
      return unavailableFallback(config, uiCode);
    }

    const warehouses =
      (config.destination_warehouse && config.destination_warehouse.entries) || [];
    const whitelist = {};
    warehouses.forEach(function (warehouse) {
      if (warehouse.warehouse_name) whitelist[warehouse.warehouse_name] = true;
    });

    const primaryMeta = findWarehouseEntry(warehouses, primaryWarehouseName);
    if (!primaryMeta || !whitelist[primaryWarehouseName]) {
      return unavailableFallback(config, uiCode);
    }

    const variantConfig = (config.variants && config.variants[String(variantId)]) || {};
    const entries = parseWarehouseAvailabilityEntries(variantConfig.warehouse_availability).filter(
      function (entry) {
        return whitelist[entry.warehouse];
      }
    );
    const stockByName = buildStockByWarehouseName(entries);

    const deliveryRegion = normalizeDeliveryRegion(primaryMeta.delivery_region);
    let regionalCandidates = getWarehousesByDeliveryRegion(warehouses, deliveryRegion).filter(
      function (warehouse) {
        return whitelist[warehouse.warehouse_name];
      }
    );
    if (!regionalCandidates.length) regionalCandidates = [primaryMeta];

    const bestLocal = pickBestInStockWarehouse(regionalCandidates, stockByName);
    if (bestLocal) {
      return {
        country: uiCode,
        status: 'in_stock',
        status_label: (config.strings && config.strings.in_stock) || 'In stock',
        shipping_text: buildShippingText(bestLocal, 'local'),
        unavailable_message: null,
      };
    }

    if (deliveryRegion !== INTERNATIONAL_DELIVERY_REGION && uiRegionAllowsCnFallback(uiCode, config)) {
      let internationalCandidates = getWarehousesByDeliveryRegion(
        warehouses,
        INTERNATIONAL_DELIVERY_REGION
      ).filter(function (warehouse) {
        return whitelist[warehouse.warehouse_name];
      });

      if (!internationalCandidates.length && whitelist[CN_WAREHOUSE_NAME]) {
        const cnEntry = findWarehouseEntry(warehouses, CN_WAREHOUSE_NAME);
        if (cnEntry) internationalCandidates = [cnEntry];
      }

      const bestInternational = pickBestInStockWarehouse(internationalCandidates, stockByName);
      if (bestInternational) {
        return {
          country: uiCode,
          status: 'available',
          status_label: (config.strings && config.strings.available) || 'Available',
          shipping_text: buildShippingText(bestInternational, 'international'),
          unavailable_message: null,
        };
      }
    }

    return unavailableFallback(config, uiCode);
  }

  class MetafieldLookupProvider {
    async getAvailability({ variantId, country, config }) {
      return computeMetafieldAvailability({
        variantId: variantId,
        country: country,
        config: config,
      });
    }

    async getRegions({ variantId, config }) {
      const codes = config.regions_panel_countries || [];
      const regions = codes.map(function (code) {
        const result = computeMetafieldAvailability({
          variantId: variantId,
          country: code,
          config: config,
        });
        return {
          country_code: code,
          country_name: getCountryName(config, code),
          status: result.status,
          status_label: result.status_label,
          shipping_text: result.shipping_text,
          unavailable_message: result.unavailable_message,
        };
      });
      return { regions: regions };
    }
  }

  function normalizeCountryCode(code) {
    if (!code) return null;
    const normalized = String(code).trim().toUpperCase();
    if (normalized === 'UK') return 'UK';
    if (normalized === 'EU') return 'EU';
    return /^[A-Z]{2}$/.test(normalized) ? normalized : null;
  }

  function getManualCountry() {
    try {
      if (localStorage.getItem(STORAGE_MANUAL_KEY) === '1') {
        return normalizeRegionCode(normalizeCountryCode(localStorage.getItem(STORAGE_KEY)));
      }
    } catch (e) {}
    return null;
  }

  async function getGeoIpCountry() {
    try {
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const response = await fetch(root + 'browsing_context_suggestions.json?country[enabled]=true');
      if (!response.ok) return null;
      const data = await response.json();
      return normalizeCountryCode(data && data.detected_values && data.detected_values.country && data.detected_values.country.handle);
    } catch (e) {
      return null;
    }
  }

  async function resolveDestinationCountry(config, element) {
    function toUiRegion(code) {
      return mapIsoToUiRegion(code, config) || 'US';
    }

    const manualCountry = getManualCountry();
    if (manualCountry) return toUiRegion(manualCountry);

    if (element.dataset.customerLoggedIn === 'true' && element.dataset.customerCountry) {
      const accountCountry = normalizeCountryCode(element.dataset.customerCountry);
      if (accountCountry) return toUiRegion(accountCountry);
    }

    const geoIpCountry = await getGeoIpCountry();
    if (geoIpCountry) return toUiRegion(geoIpCountry);

    return 'US';
  }

  function createDataProvider(element, config) {
    return new MetafieldLookupProvider();
  }

  if (!customElements.get('destination-availability')) {
    customElements.define(
      'destination-availability',
      class DestinationAvailability extends HTMLElement {
        constructor() {
          super();
          this.config = null;
          this.provider = null;
          this.country = 'US';
          this.variantId = '';
          this.variantSku = '';
          this.bundlerObserver = null;
          this.variantUnsubscriber = null;
          this.isReady = false;
          this.regionsLoaded = false;
          this.regionsPanelOpen = false;
          this.availabilityRequestId = 0;
          this.regionsRequestId = 0;
          this.ignoreNextCountryClick = false;
          this.ignoreNextRegionsClick = false;
        }

        connectedCallback() {
          this.config = parseJsonScript(this, '[data-destination-availability-config]');
          if (!this.config) return;

          this.config = applyCountryConfig(this, this.config);
          this.provider = createDataProvider(this, this.config);
          this.variantId = this.dataset.variantId || '';
          this.variantSku = this.dataset.variantSku || '';

          this.cacheDom();
          this.buildCountryList();
          this.bindEvents();
          this.activate();
          this.setupBundleNoteWatcher();
          this.setupVariantListener();
        }

        disconnectedCallback() {
          if (this.bundlerObserver) this.bundlerObserver.disconnect();
          if (this.variantUnsubscriber) this.variantUnsubscriber();
          if (this.optionChangeUnsubscriber) this.optionChangeUnsubscriber();
          if (this.selectedVariantObserver) this.selectedVariantObserver.disconnect();
          if (this.variantInput && this.onVariantInputChange) {
            this.variantInput.removeEventListener('change', this.onVariantInputChange);
          }
          document.removeEventListener('click', this.onDocumentClick);
          document.removeEventListener('keydown', this.onDocumentKeydown);
          document.removeEventListener('bundler:bundle_widget_created', this.onBundlerReady);
        }

        cacheDom() {
          this.card = this.querySelector('.destination-availability__card');
          this.countryTrigger = this.querySelector('.destination-availability__country-trigger');
          this.countryPanel = this.querySelector('.destination-availability__country-panel');
          this.countryList = this.querySelector('.destination-availability__country-list');
          this.countryFlag = this.querySelector('.destination-availability__country-flag');
          this.countryNameEl = this.querySelector('.destination-availability__country-name');
          this.summaryEl = this.querySelector('.destination-availability__summary');
          this.statusRow = this.querySelector('.destination-availability__status-row');
          this.statusLabel = this.querySelector('.destination-availability__status-label');
          this.shippingText = this.querySelector('.destination-availability__shipping-text');
          this.unavailableMessage = this.querySelector('.destination-availability__unavailable-message');
          this.regionsToggle = this.querySelector('.destination-availability__regions-toggle');
          this.regionsPanel = this.querySelector('.destination-availability__regions-panel');
          this.regionsList = this.querySelector('.destination-availability__regions-list');
          this.bundleNote = this.querySelector('.destination-availability__bundle-note');
          this.loadingEl = this.querySelector('.destination-availability__loading');
          this.errorEl = this.querySelector('.destination-availability__error');

          this.onDocumentClick = this.handleDocumentClick.bind(this);
          this.onDocumentKeydown = this.handleDocumentKeydown.bind(this);
          this.onBundlerReady = this.handleBundlerReady.bind(this);
        }

        bindEvents() {
          if (this.countryTrigger) {
            this.countryTrigger.addEventListener('click', this.toggleCountryPanel.bind(this));
            this.countryTrigger.addEventListener('keydown', this.handleCountryTriggerKeydown.bind(this));
          }
          if (this.regionsToggle) {
            this.regionsToggle.addEventListener('click', this.toggleRegionsPanel.bind(this));
            this.regionsToggle.addEventListener('keydown', this.handleRegionsToggleKeydown.bind(this));
          }
          document.addEventListener('click', this.onDocumentClick);
          document.addEventListener('keydown', this.onDocumentKeydown);
          document.addEventListener('bundler:bundle_widget_created', this.onBundlerReady);
        }

        setupVariantListener() {
          var self = this;

          if (typeof subscribe === 'function') {
            this.variantUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
              const sectionId = self.dataset.sectionId;
              if (!event.data || String(event.data.sectionId) !== String(sectionId)) return;
              const variant = event.data.variant;
              if (!variant || !variant.id) return;
              self.applyVariantChange(String(variant.id), variant.sku || '');
            });

            // Fallback: option clicks fetch section async; sync again when selection changes.
            this.optionChangeUnsubscriber = subscribe(
              PUB_SUB_EVENTS.optionValueSelectionChange,
              function (event) {
                if (!event.data || !event.data.event) return;
                if (!self.closest('product-info') || !self.closest('product-info').contains(event.data.event.target)) {
                  return;
                }
                self.scheduleVariantFormSync();
              }
            );
          }

          const productInfo = this.closest('product-info');
          const sectionId = this.dataset.sectionId;
          this.variantInput =
            document.querySelector('#product-form-' + sectionId + ' input[name="id"]') ||
            (productInfo && productInfo.querySelector('form[action*="/cart/add"] input[name="id"]')) ||
            null;

          if (this.variantInput) {
            this.onVariantInputChange = function () {
              const id = self.variantInput.value;
              if (!id) return;
              const variantConfig = (self.config.variants && self.config.variants[String(id)]) || {};
              self.applyVariantChange(String(id), variantConfig.sku || self.variantSku);
            };
            this.variantInput.addEventListener('change', this.onVariantInputChange);
          }

          // Watch selected-variant JSON node (updated by section HTML swap).
          this.selectedVariantNode =
            (productInfo && productInfo.querySelector('variant-selects [data-selected-variant]')) || null;
          if (this.selectedVariantNode && window.MutationObserver) {
            this.selectedVariantObserver = new MutationObserver(function () {
              self.syncFromSelectedVariantNode();
            });
            this.selectedVariantObserver.observe(this.selectedVariantNode, {
              characterData: true,
              childList: true,
              subtree: true,
            });
          }
        }

        scheduleVariantFormSync() {
          var self = this;
          [50, 300, 800, 1600].forEach(function (ms) {
            window.setTimeout(function () {
              self.syncFromSelectedVariantNode();
              if (!self.variantInput || !self.variantInput.value) return;
              const id = String(self.variantInput.value);
              const variantConfig = (self.config.variants && self.config.variants[id]) || {};
              self.applyVariantChange(id, variantConfig.sku || self.variantSku);
            }, ms);
          });
        }

        syncFromSelectedVariantNode() {
          if (!this.selectedVariantNode) return;
          try {
            const variant = JSON.parse(this.selectedVariantNode.textContent || 'null');
            if (!variant || !variant.id) return;
            this.applyVariantChange(String(variant.id), variant.sku || '');
          } catch (e) {}
        }

        applyVariantChange(variantId, sku) {
          if (!variantId || String(variantId) === String(this.variantId)) return;

          this.variantId = String(variantId);
          this.variantSku = sku || '';
          this.dataset.variantId = this.variantId;
          this.dataset.variantSku = this.variantSku;

          // Drop any in-flight async renders from the previous variant.
          this.availabilityRequestId += 1;
          this.regionsRequestId += 1;

          if (!this.isReady) return;

          // Sync path: main status + regions list always use the same variantId.
          this.renderCurrentVariantState({ alwaysUpdateRegions: true });
        }

        isRegionsPanelOpen() {
          if (this.regionsPanelOpen) return true;
          if (!this.regionsPanel) return false;
          return !this.regionsPanel.hidden && !this.regionsPanel.hasAttribute('hidden');
        }

        /**
         * Render summary (and regions) from embedded config for this.variantId.
         * Synchronous so main + regions cannot diverge across async races.
         */
        renderCurrentVariantState(options) {
          options = options || {};
          const variantId = String(this.variantId || '');
          if (!variantId || !this.config) return;

          const result = computeMetafieldAvailability({
            variantId: variantId,
            country: this.country,
            config: this.config,
          });
          this.renderAvailability(result);
          this.updateCountryDisplay(this.country);

          const updateRegions =
            options.alwaysUpdateRegions ||
            this.isRegionsPanelOpen() ||
            this.regionsLoaded ||
            (this.regionsList && this.regionsList.children.length > 0);

          if (updateRegions) {
            this.renderRegionsForVariant(variantId);
          }
        }

        renderRegionsForVariant(variantId) {
          if (!this.regionsList || !this.config) return;
          const self = this;
          const id = String(variantId || this.variantId);
          const codes = this.config.regions_panel_countries || [];
          const rows = codes.map(function (code) {
            const result = computeMetafieldAvailability({
              variantId: id,
              country: code,
              config: self.config,
            });
            return {
              country_code: code,
              country_name: getCountryName(self.config, code),
              status: result.status,
              status_label: result.status_label,
              shipping_text: result.shipping_text,
              unavailable_message: result.unavailable_message,
            };
          });

          this.renderRegions(rows);
          this.regionsList.dataset.variantId = id;
          this.regionsLoaded = true;
        }

        syncVariantFromForm() {
          if (!this.variantInput || !this.variantInput.value) return;
          const id = String(this.variantInput.value);
          if (id === String(this.variantId)) return;
          const variantConfig = (this.config.variants && this.config.variants[id]) || {};
          this.variantId = id;
          this.variantSku = variantConfig.sku || this.variantSku;
          this.dataset.variantId = this.variantId;
          this.dataset.variantSku = this.variantSku;
        }

        setupBundleNoteWatcher() {
          updateBundleNoteVisibility(this.bundleNote);

          if (bundlerHasContent()) return;

          const target = getBundlerObserveTarget();
          if (target && window.MutationObserver) {
            this.bundlerObserver = new MutationObserver(() => {
              if (!bundlerHasContent()) return;
              updateBundleNoteVisibility(this.bundleNote);
              if (this.bundlerObserver) {
                this.bundlerObserver.disconnect();
                this.bundlerObserver = null;
              }
            });
            this.bundlerObserver.observe(target, { childList: true, subtree: true });
          }
        }

        handleBundlerReady() {
          updateBundleNoteVisibility(this.bundleNote);
        }

        activate() {
          if (this.isReady) return;
          this.isReady = true;
          this.hidden = false;
          updateBundleNoteVisibility(this.bundleNote);
          this.initializeCountryAndAvailability();
        }

        initializeCountryAndAvailability() {
          var self = this;
          resolveDestinationCountry(this.config, this)
            .then(function (country) {
              self.country = country || 'US';
              return self.refreshAvailability();
            })
            .catch(function () {
              self.country = 'US';
              return self.refreshAvailability();
            });
        }

        buildCountryList() {
          if (!this.countryList) return;
          this.countryList.innerHTML = '';
          (this.config.countries || []).forEach((country) => {
            const li = document.createElement('li');
            const btn = document.createElement('button');
            btn.type = 'button';
            btn.className = 'destination-availability__country-option';
            btn.dataset.countryCode = country.code;
            btn.innerHTML =
              '<img class="destination-availability__country-flag" src="' +
              flagUrl(country.code) +
              '" alt="" width="20" height="15" loading="lazy">' +
              '<span>' +
              country.name +
              '</span>';
            btn.addEventListener('click', () => this.selectCountry(country.code));
            li.appendChild(btn);
            this.countryList.appendChild(li);
          });
        }

        isActivateKey(event) {
          return event.key === 'Enter' || event.key === ' ';
        }

        handleCountryTriggerKeydown(event) {
          if (!this.isActivateKey(event)) return;
          event.preventDefault();
          event.stopPropagation();
          this.ignoreNextCountryClick = true;
          this.toggleCountryPanel();
          window.setTimeout(() => {
            this.ignoreNextCountryClick = false;
          }, 0);
        }

        handleRegionsToggleKeydown(event) {
          if (!this.isActivateKey(event)) return;
          event.preventDefault();
          event.stopPropagation();
          this.ignoreNextRegionsClick = true;
          this.toggleRegionsPanel();
          window.setTimeout(() => {
            this.ignoreNextRegionsClick = false;
          }, 0);
        }

        toggleCountryPanel(event) {
          if (event && event.type === 'click' && this.ignoreNextCountryClick) {
            event.stopPropagation();
            return;
          }
          if (event) event.stopPropagation();
          if (!this.countryPanel) return;
          this.setCountryPanelOpen(this.countryPanel.hidden);
        }

        setCountryPanelOpen(open) {
          if (!this.countryPanel || !this.countryTrigger) return;
          this.countryPanel.hidden = !open;
          this.countryTrigger.setAttribute('aria-expanded', open ? 'true' : 'false');
        }

        handleDocumentClick(event) {
          if (this.card && !this.card.contains(event.target)) {
            if (this.isRegionsPanelOpen()) {
              this.setRegionsPanelOpen(false);
            }
          }
          if (!this.countryPanel || this.countryPanel.hidden) return;
          if (event.target.closest('.destination-availability__country-select')) return;
          this.setCountryPanelOpen(false);
        }

        handleDocumentKeydown(event) {
          if (event.key !== 'Escape') return;
          if (this.countryPanel && !this.countryPanel.hidden) {
            event.preventDefault();
            this.setCountryPanelOpen(false);
            if (this.countryTrigger) this.countryTrigger.focus();
            return;
          }
          if (this.isRegionsPanelOpen()) {
            event.preventDefault();
            this.setRegionsPanelOpen(false);
            if (this.regionsToggle) this.regionsToggle.focus();
          }
        }

        selectCountry(code) {
          this.country = normalizeRegionCode(code) || code;
          try {
            localStorage.setItem(STORAGE_KEY, this.country);
            localStorage.setItem(STORAGE_MANUAL_KEY, '1');
          } catch (e) {}
          this.setCountryPanelOpen(false);
          if (this.countryTrigger) this.countryTrigger.focus();
          this.regionsLoaded = false;
          this.setRegionsPanelOpen(false);
          this.refreshAvailability();
        }

        updateCountryDisplay(code) {
          const name = getCountryName(this.config, code);
          if (this.countryFlag) {
            this.countryFlag.src = flagUrl(code);
            this.countryFlag.alt = name;
          }
          if (this.countryNameEl) this.countryNameEl.textContent = name;
          if (this.countryList) {
            this.countryList.querySelectorAll('.destination-availability__country-option').forEach((btn) => {
              if (btn.dataset.countryCode === code) {
                btn.setAttribute('aria-current', 'true');
              } else {
                btn.removeAttribute('aria-current');
              }
            });
          }
        }

        setLoading(isLoading) {
          if (this.loadingEl) this.loadingEl.hidden = !isLoading;
          if (this.errorEl && isLoading) this.errorEl.hidden = true;
        }

        setError(show) {
          if (this.errorEl) this.errorEl.hidden = !show;
        }

        renderAvailability(result) {
          const status = result.status || 'unavailable';
          if (this.summaryEl) this.summaryEl.dataset.status = status;
          if (this.statusLabel) this.statusLabel.textContent = result.status_label || '';

          if (this.shippingText) {
            if (result.shipping_text) {
              this.shippingText.textContent = result.shipping_text;
              this.shippingText.hidden = false;
            } else {
              this.shippingText.textContent = '';
              this.shippingText.hidden = true;
            }
          }

          if (this.unavailableMessage) {
            if (result.unavailable_message) {
              this.unavailableMessage.textContent = result.unavailable_message;
              this.unavailableMessage.hidden = false;
            } else {
              this.unavailableMessage.textContent = '';
              this.unavailableMessage.hidden = true;
            }
          }
        }

        async refreshAvailability(forcedVariantId, forcedSku) {
          if (forcedVariantId) {
            this.variantId = String(forcedVariantId);
            if (forcedSku != null) this.variantSku = forcedSku;
          } else {
            this.syncVariantFromForm();
          }
          this.renderCurrentVariantState({
            alwaysUpdateRegions: this.isRegionsPanelOpen() || this.regionsLoaded,
          });
        }

        async toggleRegionsPanel(event) {
          if (event && event.type === 'click' && this.ignoreNextRegionsClick) {
            event.stopPropagation();
            return;
          }
          if (event) event.stopPropagation();
          if (!this.regionsPanel) return;
          const willOpen = !this.isRegionsPanelOpen();
          this.setRegionsPanelOpen(willOpen);
          if (!willOpen) return;
          this.syncVariantFromForm();
          this.renderRegionsForVariant(this.variantId);
        }

        setRegionsPanelOpen(open) {
          this.regionsPanelOpen = Boolean(open);
          if (this.regionsPanel) this.regionsPanel.hidden = !this.regionsPanelOpen;
          if (this.regionsToggle) {
            this.regionsToggle.setAttribute('aria-expanded', this.regionsPanelOpen ? 'true' : 'false');
            const strings = (this.config && this.config.strings) || {};
            this.regionsToggle.textContent = this.regionsPanelOpen
              ? strings.hide_other_regions || 'Hide availability in other regions'
              : strings.other_regions || 'View availability in other regions';
          }
        }

        async reloadRegions(forcedVariantId, forcedSku) {
          if (forcedVariantId) {
            this.variantId = String(forcedVariantId);
            if (forcedSku != null) this.variantSku = forcedSku;
          } else {
            this.syncVariantFromForm();
          }
          this.renderRegionsForVariant(this.variantId);
        }

        renderRegions(regions) {
          if (!this.regionsList) return;
          this.regionsList.innerHTML = '';
          const genericUnavailable =
            (this.config.strings && this.config.strings.not_available_generic) ||
            'Not available for delivery at this time';

          regions.forEach((item) => {
            const detailText =
              item.shipping_text ||
              (item.status === 'unavailable' ? genericUnavailable : '') ||
              item.unavailable_message ||
              '';

            const li = document.createElement('li');
            li.className = 'destination-availability__regions-item';
            li.innerHTML =
              '<div class="destination-availability__regions-country">' +
              '<img class="destination-availability__country-flag" src="' +
              flagUrl(item.country_code) +
              '" alt="" width="22" height="16" loading="lazy">' +
              '<span class="destination-availability__regions-country-name">' +
              item.country_name +
              '</span>' +
              '</div>' +
              '<div class="destination-availability__regions-detail">' +
              '<div class="destination-availability__regions-status" data-status="' +
              item.status +
              '">' +
              STATUS_DOT_HTML +
              '<span>' +
              item.status_label +
              '</span>' +
              '</div>' +
              (detailText
                ? '<p class="destination-availability__regions-shipping">' + detailText + '</p>'
                : '') +
              '</div>';
            this.regionsList.appendChild(li);
          });
        }
      }
    );
  }
})();
